import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  DoCheck,
} from "@angular/core";
import * as XLSX from "xlsx";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import * as FileSaver from "file-saver";
import { HomeService } from "./home.services";
import _ from "underscore";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { PatentInfoComponent } from "./patent-info/patent-info.component";
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { environment } from "src/environments/environment.prod";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic'; // CKEditor build
// import { AngularEditorModule } from '@kolkov/angular-editor';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  @ViewChild("headerids", { static: false }) headerids: ElementRef;
  links = 'window.open("http://43.205.223.1:8000';
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  secondSectionData: any = {};
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  activeIngredientforPI: any;
  ndaforPI: any;
  brandNameforPI: any;
  CostingData: any = {};
  ipAddress = "";
  uniqNumber: any;
  UserIp: any;
  email: any;
  acceptLoader: boolean = false;
  rejectLoader: boolean = false;
  htmlContent: '';
  ShowLmsMessage: any;
  fieldInformation: any;
  displayReviewDialog: boolean = false;
  selectedKey: string = '';
  selectedEmail: any;
  reviewComment: string = '';
  emailList: any[] = [];
  drugName: any;
  drugActiveIngredient: any;
  drugNdaNumber: any;
  drugDosageForm: any;
  submitted: boolean = false; // Track form submission
  verificationMessage: string = '';
  responseData = {
    "fillvolume": [1, 2, 3],
    "ACTIVE A": [4, 5, 6],
    "ACTIVE B": [7, 8, 9]
  };
  public Editor = ClassicEditor;
  public editorData = '<p>Type your content here...</p>';
  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: 'auto',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter text here...',
  //   defaultParagraphSeparator: '',
  //   defaultFontName: '',
  //   defaultFontSize: '',
  //   toolbarHiddenButtons: [
  //     ['bold']
  //   ],
  //   sanitize: true,
  //   toolbarPosition: 'top',
  //   outline: false,
  // };


  // user specific page allowance.
  page_access = { total_count: "undefined" };
  total_count = "undefined";
  saveOldData: any;
  patentHeader: string = 'PATENT INFORMATION';
  InnovatorHeader: string = 'INNOVATOR/BRAND PRODUCT DETAILS';
  regulatoryHeader: string = 'REGULATORY INFORMATION';
  clinicalHeader: string = 'CLINICAL INFORMATION';
  APIInformationHeader: string = 'API INFORMATION';
  formulationHeader: string = 'FORMULATION INFORMATION';
  competitiveHeader: string = 'COMPETITIVE INTELLIGENCE';
  executiveHeader: string = 'EXECUTIVE SUMMARY';
  costingRelatedHeader: string = 'COSTING RELATED AND DETAILS';
  litigationHeader: string = 'LITIGATION INFORMATION';

  isProductLive: boolean = false;
  constructor(
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private directoryservice: DataDirectoryService,
    private homeservice: HomeService,
    private sanitized: DomSanitizer
  ) {
    this.submolecules = [];
    if (
      this.directoryservice.serchKey &&
      this.directoryservice.serchKey != ""
    ) {
      this.searchValue = this.directoryservice.serchKey;
    }
  }
  ngOnInit() {
    this.uniqNumber = this.route.snapshot.queryParams["uniqnumber"];
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.fetchEmails();
    console.log("unique", this.uniqNumber);
    // this.onPatentHeaderUpdate('Manually triggered header update');

    this.getIP();
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue,
        this.UserIp,
        this.uniqNumber,
        this.email
      );
      this.Molecule = true;
    }
    this.page_access = JSON.parse(localStorage.getItem("page_access")) || {
      total_count: "undefined",
    };
    this.total_count = this.page_access.total_count || "undefined";
  }

  responseKeys = Object.keys(this.responseData);
  columnIndexes = Array(this.responseData[this.responseKeys[0]].length).fill(0).map((_, i) => i);

  updateHeader(index: number) {
    const oldKey = Object.keys(this.responseData)[index];
    const newKey = this.responseKeys[index];

    if (oldKey !== newKey) {
      Object.defineProperty(this.responseData, newKey, Object.getOwnPropertyDescriptor(this.responseData, oldKey)!);
      delete this.responseData[oldKey];
    }
  }

  onPatentHeaderUpdate(updatedHeader: string) {
    this.patentHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onLitigationUpdate(updatedHeader: string) {
    this.litigationHeader = updatedHeader;
    this.ref.detectChanges();
  }


  onApiInformationUpdate(updatedHeader: string) {
    this.APIInformationHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onFormulationUpdate(updatedHeader: string) {
    this.formulationHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onClinicalUpdate(updatedHeader: string) {
    this.clinicalHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onRegulatoryUpdate(updatedHeader: string) {
    this.regulatoryHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onCompetitiveUpdate(updatedHeader: string) {
    this.competitiveHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onExecutiveUpdate(updatedHeader: string) {
    this.executiveHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  onCostingRelatedUpdate(updatedHeader: string) {
    this.costingRelatedHeader = updatedHeader; // Update the header based on the child component's data
    this.ref.detectChanges();
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  // Helper function to get object keys
  isobjectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  addColumn() {
    this.columnIndexes.push(this.columnIndexes.length);
    this.responseKeys.forEach(key => {
      this.responseData[key].push('');
    });
  }

  addRow() {
    const newKey = `New Row ${this.responseKeys.length + 1}`;
    const newRow = new Array(this.columnIndexes.length).fill('');

    this.responseData[newKey] = newRow;
    this.responseKeys = Object.keys(this.responseData);

    this.ref.detectChanges();
  }

  deleteNewRow(rowIndex: number) {
    const keyToDelete = this.responseKeys[rowIndex];
    delete this.responseData[keyToDelete];
    this.responseKeys.splice(rowIndex, 1); // Remove the key from the array
  }

  deleteColumn(colIndex: number) {
    this.columnIndexes.splice(colIndex, 1); // Remove the column index

    this.responseKeys.forEach(key => {
      this.responseData[key].splice(colIndex, 1); // Remove the value from each row
    });
  }

  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.Molecule = false;
    this.searchValue = "";
    this.subMolecule = false;
    this.noData = false;
  }
  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.homeservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  // arrayToDropdown(InputArray) {
  //   let DropDownArray = [];
  //   console.log("dropdown array", DropDownArray)
  //   InputArray.forEach((DropdownValues) => {
  //     let dropDownObj = {};
  //     dropDownObj["name"] = DropdownValues;
  //     dropDownObj["code"] = DropdownValues;
  //     DropDownArray.push(dropDownObj);
  //   });
  //   return DropDownArray;
  // }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {
        name: `${DropdownValues.brand_name},${DropdownValues.nda_number},${DropdownValues.dosage_forms}`,
        code: DropdownValues // store the full object for later use
      };
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }
  /**
   * Method to handle search
   */

  searchMolecule() {
    this.submolecules = [];
    this.homeservice.getNdaData(this.searchValue).subscribe((ndaValues: any) => {
      if (ndaValues["data"].nda_numbers.length > 0) {
        let dropdownvalues = this.arrayToDropdown(ndaValues["data"].nda_numbers);
        console.log("dropdownnn", dropdownvalues)
        this.submolecules = dropdownvalues;
        this.subMolecule = true;
        this.Molecule = false;
        this.DragData = {};
        this.refEditData = {};
      } else {
        this.selectedSubMolecule = {};
        this.subMolecule = false;
        this.Molecule = false;
        this.DragData = {};
        this.refEditData = {};
        this.tempData = {};
      }
    });
  }

  getIP() {
    this.homeservice.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
      // console.log(this.ipAddress)
      localStorage.setItem("ipaddress", res.ip);
    });
    // this.saveip();
  }

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    // let userIp = localStorage.getItem('ipaddress');

    this.getEditedChanges(
      active_ingredient,
      brand_name,
      ndaNumber,
      this.UserIp,
      this.uniqNumber,
      this.email
    );
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number,
    userIp: string,
    uniqnumber: number,
    email: string
  ) {
    this.homeservice
      .sectionOneEditedData(
        active_ingredient,
        brand_name,
        ndaNumber,
        userIp,
        uniqnumber,
        email
      )
      .subscribe((res: any) => {
        console.log("response from Home component", res);
        if (this.paramsValues.section === "innovator_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  getData() {
    if (this.selectedSubMolecule !== undefined) {
      console.log("this.selectedSubMolecule", this.selectedSubMolecule["code"])
      let selectedMoleculeData = this.selectedSubMolecule["code"];
      console.log("nda value", selectedMoleculeData)
      let ndaValue = selectedMoleculeData["nda_number"]
      let brandValue = selectedMoleculeData["brand_name"]
      let DosageValue = selectedMoleculeData["dosage_forms"]
      let newData = {
        "nda_number": ndaValue,
        "brand_name": brandValue,
        "dosage_forms": DosageValue
      }
      this.homeservice.getDrugData(newData).subscribe((MoleculeData: any) => {
        if (MoleculeData !== null) {
          localStorage.setItem("molecules", JSON.stringify(MoleculeData));
          this.saveOldData = MoleculeData;
          let referdata: any = localStorage.getItem("molecules");
          let moleculedata: any = JSON.parse(referdata);
          let active_ingredient: any;
          // if (Array.isArray(MoleculeData["Active Ingredient"]) === false) {
          //   active_ingredient = moleculedata["Active Ingredient"].replace(
          //     /\s/g,
          //     "%20"
          //   );
          // } else {
          //   active_ingredient = moleculedata["Active Ingredient"]
          //     .join("&")
          //     .replace(/\s/g, "%20");
          // }
          // let brand_name = moleculedata["Brand Name/Proprietary Name"].replace(
          //   /\s/g,
          //   "_"
          // ).replaceAll(/%/g, "@");
          if (!Array.isArray(moleculedata["Active Ingredient"])) {
            active_ingredient = moleculedata["Active Ingredient"];
          } else {
            active_ingredient = moleculedata["Active Ingredient"].join("&");
          }

          let brand_name = moleculedata["Brand Name/Proprietary Name"];
          let ndaValue = moleculedata["NDA number"];
          let sectionOne = "innovator_details";

          const base64Encode = (str: string): string => {
            return btoa(unescape(encodeURIComponent(str)))
              .replace(/\+/g, '-')
              .replace(/\//g, '_')
              .replace(/=+$/, '');
          };

          const encodedActiveIngredient = base64Encode(active_ingredient);
          const encodedBrandName = base64Encode(brand_name);
          this.linkURL = `${environment.ip}/#/home?active_ingredient=${encodedActiveIngredient}&brand_name=${encodedBrandName}&ndaValue=${ndaValue}&section=${sectionOne}`;
          // this.linkURL = `http://3.111.249.237/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
          // this.linkURL = `${environment.ip}/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
          // this.linkURL = `http://localhost:4200//#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionOne}`;
          this.noData = false;
          this.ref.detectChanges();
          this.brandNameforPI = brand_name;
          this.ndaforPI = ndaValue;
          this.activeIngredientforPI = active_ingredient;
          let userIp = localStorage.getItem("ipaddress");

          // Calling First Section API
          this.homeservice
            .getFirstSection(ndaValue, brand_name, userIp)
            .subscribe((InnovatorDetails: any) => {
              this.isProductLive = InnovatorDetails?.['is_product_live'];
              this.Molecule = true;
              //extract colour coding
              this.ShowLmsMessage = InnovatorDetails?.['status_message']
              this.colorcode =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"][
                "colorindicator"
                ];
              this.fieldInformation = InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"]["field_information"];
              console.log("fieldInformation", this.fieldInformation)
              this.checkFieldVerificationStatus();
              this.InnovatorHeader = this.verificationMessage;

              console.log(this.colorcode);
              this.DragData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              console.log(this.DragData);
              this.tempData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              console.log(this.tempData);
              this.refEditData =
                InnovatorDetails.data["INNOVATOR/BRAND PRODUCT DETAILS"];
              console.log(this.refEditData);
            });
        } else {
          this.noData = true;
          this.Molecule = false;
          this.DragData = {};
          this.tempData = {};
          this.refEditData = {};
        }
      });
    }
  }

  checkFieldVerificationStatus() {
    // Start with the default message
    let verificationMessage = 'INNOVATOR/BRAND PRODUCT DETAILS';

    // Iterate over each section (key) in fieldInformation
    for (const section in this.fieldInformation) {
      if (this.fieldInformation.hasOwnProperty(section)) {
        // Check if any item in the current section has field_verified as false
        const unverifiedField = this.fieldInformation[section].some(item => item.field_verified === false || item.field_verified === "N/A");

        if (unverifiedField) {
          // Add HTML span for highlighting the pending verification part
          verificationMessage += " - Verification of field is pending";
          break; // Stop after the first match (you can continue checking all sections if needed by removing this line)
        }
      }
    }

    // Store the final message (HTML)
    this.verificationMessage = verificationMessage;

    // Optionally, log the verification message
    console.log(this.verificationMessage);
  }

  selectedFilenames: Map<any, string> = new Map();

  onFileSelected(event: any, Obj: any, key: string) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]; // Get only the base64 part

        const nda = this.saveOldData["NDA number"] || '';
        const brand = this.saveOldData["Brand Name/Proprietary Name"] || '';
        const generatedPath = `media/FDA_Label_pdf_folder/${nda}_${brand}.pdf`;

        Obj.value['file'] = base64String; // Binary data in 'file' key
        Obj.value[key] = generatedPath; // Generated path in 'path' key

        this.selectedFilenames.set(Obj.value, file.name); // Store original filename for UI display
        this.toastr.success("File attached. Changes will be saved on 'Save'.", "Success");
      };
      reader.readAsDataURL(file);
    }
  }

  setNA(Obj: any, key: string) {
    if (Obj.value[key] === "N/A") {
      // Toggle off: Restore from backup if available
      if (this.fdaLabelBackup && this.fdaLabelBackup[key]) {
        Obj.value[key] = this.fdaLabelBackup[key];
      }
    } else {
      // Toggle on: Set to N/A
      Obj.value[key] = "N/A";
    }
    delete Obj.value['file'];
    this.selectedFilenames.delete(Obj.value);
  }

  onDateSelect(event: any, Obj: any, key: string) {
    const date = new Date(event);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    Obj.value[key] = `${day}/${month}/${year}`;
  }

  HandleInput(evt) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length !== 1) throw new Error("Cannot use multiple files");
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      let x = this.data.slice(1);
    };
    reader.readAsBinaryString(target.files[0]);
  }

  fdaLabelBackup: any = {};

  /**
   * Robustly parses a date string into a Date object.
   * Supports: DD/MM/YYYY, DD-MM-YYYY, YYYY-MM-DD, MM/DD/YYYY, and ISO strings.
   */
  parseDate(dateStr: any): Date | null {
    if (!dateStr || dateStr === 'N/A') return null;
    // Already a Date object
    if (dateStr instanceof Date) return dateStr;
    const str = String(dateStr).trim();
    // DD/MM/YYYY or DD-MM-YYYY
    const ddmmyyyy = str.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/);
    if (ddmmyyyy) {
      const d = new Date(+ddmmyyyy[3], +ddmmyyyy[2] - 1, +ddmmyyyy[1]);
      if (!isNaN(d.getTime())) return d;
    }
    // YYYY-MM-DD or YYYY/MM/DD
    const yyyymmdd = str.match(/^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})/);
    if (yyyymmdd) {
      const d = new Date(+yyyymmdd[1], +yyyymmdd[2] - 1, +yyyymmdd[3]);
      if (!isNaN(d.getTime())) return d;
    }
    // Fallback to native parse (handles ISO 8601 & MM/DD/YYYY)
    const fallback = new Date(str);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  formatDate(dateVal: any): string {
    if (!dateVal || dateVal === 'N/A') return 'N/A';

    const date = this.parseDate(dateVal);
    if (!date) return dateVal;

    if (isNaN(date.getTime())) return dateVal;

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      if (this.DragData['FDA label']) {
        this.fdaLabelBackup = JSON.parse(JSON.stringify(this.DragData['FDA label']));
        // Convert existing 'action date' strings to Date objects so p-calendar can display them
        const rows = Array.isArray(this.DragData['FDA label'])
          ? this.DragData['FDA label']
          : [this.DragData['FDA label']];
        rows.forEach(row => {
          if (row['action date'] && !(row['action date'] instanceof Date)) {
            row['action date'] = this.parseDate(row['action date']);
          }
        });
        this.DragData = { ...this.DragData }; // trigger change detection
        this.tempData = { ...this.DragData };
      }
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    this.homeservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData
    let columns_data = this.options;
    this.homeservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }
  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    let obj = {};
    let keys: string[];
    if (data && data.length > 0 && data[0]) {
      keys = Object.keys(data[0]);
    }
    // else if (n7 === 'FDA label') {
    //   keys = ['path', 'action date'];
    // } 
    else {
      keys = ['Default Header 1', 'Default Header 2'];
    }
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = "";
    }
    if (!Array.isArray(objdata[n7])) {
      // if (this.isObject(objdata[n7])) {
      //   objdata[n7] = [objdata[n7]];
      // } else {
      objdata[n7] = [];
      // }
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.tempData = { ...objdata };
    this.ref.markForCheck();
  }

  // addListItem(data, n4, n5, n6, n7) {
  //   let objdata: any = this.DragData;
  //   if (typeof objdata[n7] === 'string') {
  //     objdata[n7] = [objdata[n7]];
  //   }
  //   let arr = [];
  //   console.log("Arrayyyy", objdata[n7].push(arr));
  //   this.DragData = { ...objdata };
  //   this.tempData = { ...objdata };
  // }

  addListItem(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    if (typeof objdata[n7] === 'string') {
      objdata[n7] = [objdata[n7]];
    }
    let arr = [];
    console.log("Arrayyyy", objdata[n7].push(arr));
    this.DragData = { ...objdata };
    // console.log("DragData", this.DragData);
    this.tempData = { ...objdata };
  }

  // addTable(data, n4, n5, n6, n7) {
  //   let objdata: any = this.DragData;
  //   console.log("this.objdata before", objdata);

  //   // Check if objdata[n7] is an array and initialize it as a new empty array
  //   if (Array.isArray(objdata[n7])) {
  //     objdata[n7] = []; // Clear the existing data
  //   } else {
  //     objdata[n7] = []; // Initialize as an empty array if not already an array
  //   }

  //   // Transform the data structure to [{ "Header 1": "Cell 1", "Header 2": "Cell 2" }]
  //   let newRow = { "Header 1": "Cell 1", "Header 2": "Cell 2" };
  //   objdata[n7].push(newRow);

  //   this.DragData = { ...objdata };
  //   console.log("this.DragData after", this.DragData);
  //   this.tempData = { ...objdata };
  // }

  addTable(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    console.log("this.objdata before", n7);

    if (n7 === 'FDA label') {
      // if (Array.isArray(objdata[n7])) {
      //   // keep as is
      // } else if (this.isObject(objdata[n7])) {
      //   objdata[n7] = [objdata[n7]];
      // } else {
      objdata[n7] = [];
      // }
    } else if (Array.isArray(objdata[n7])) {
      objdata[n7] = [];
    } else if (typeof objdata[n7] === 'string') {
      objdata[n7] = [];
    } else {
      objdata[n7] = [];
    }

    // let newRow = { "Header 1": "Cell 1", "Header 2": "Cell 2" };

    let headers;
    switch (n7) {
      case 'Approval date / Action date (mm-dd-yyyy)':
        headers = ["Strength", "Approval Date"];
        break;
      case 'Marketing Status':
        headers = ["Strength", "Mkt Status"];
        break;
      case 'Approved in other geographies':
        headers = ["Country", "Approval Number", "Brand Name", "Route", "Dosage Form", "Active Ingredient(s)", "Strength", "Applicant", "Approval Date"];
        break;
      case 'StrengthActiveAPIFillVolume':
        headers = ["OB strength", "Strength", "Active", "Total API (mg) BASE", "Total API (mg)", "Fill Volume/Weight (ml or gm)", "Unit",
          "API Content (mg/ml or mg/gm) BASE", "API Content (mg/ml or mg/gm)", "RLD", "RS"];
        break;
      case 'FDA label':
        headers = ["path", "action date"];
        break;
      default:
        headers = ["Default Header 1", "Default Header 2"];
        break;
    }

    // Create a new row based on the defined headers
    let newRow = {};
    headers.forEach(header => {
      if (n7 === 'FDA label') {
        newRow[header] = "";
      } else {
        newRow[header] = "Cell " + (Object.keys(newRow).length + 1);
      }
    });
    objdata[n7].push(newRow);

    this.DragData = { ...objdata };
    console.log("this.DragData after", this.DragData);
    this.tempData = { ...objdata };
  }

  deleteTable(key: string) {
    let objdata: any = this.DragData;

    if (objdata.hasOwnProperty(key)) {
      objdata[key] = "N/A";
    }

    this.DragData = { ...objdata };
    this.tempData = { ...objdata };

    console.log("Table deleted for key:", key);
  }


  deleteListItem(value: any, key: any, index: number) {
    console.log("deleteItemmm", value, index);
    let objdata: any = this.DragData;
    if (value.length > 1) {
      value.splice(index, 1);

      const keysToConvert = ['Active Ingredient', 'Brand Name/Proprietary Name', 'Dosage forms',
        'Route of Administration', 'Nature of Dosage form', 'NDA number', 'Submission Classification',
        'Oneclick Marketing Status'];

      // Convert back to string if only one item left
      if (value.length === 1 && keysToConvert.includes(key)) {
        if (this.DragData[key]) {
          this.DragData[key] = value[0];
        }
      }

      this.DragData = { ...objdata };
    }
  }

  deleteRow(Obj: any, index: number) {
    let objdata: any = this.DragData;
    if (index > -1 && index < Obj.length) {
      Obj.splice(index, 1);
      console.log("deleteRow", Obj, index);
      // If all rows removed, set the key back to 'N/A'
      if (Obj.length === 0) {
        for (const key of Object.keys(objdata)) {
          if (objdata[key] === Obj) {
            objdata[key] = 'N/A';
            break;
          }
        }
      }
      this.DragData = { ...objdata };
    }
  }

  // deleteListItem(value: any, index: number, key: any) {
  //   console.log("deleteItemmm", value, index)
  //   value.splice(index, 1);

  //   const keysToConvert = ['Active Ingredient', 'Brand Name/Proprietary Name', 'Dosage forms',
  //     'Route of Administration', 'Nature of Dosage form', 'NDA number', 'Submission Classification',
  //     'Oneclick Marketing Status'];
  //   if (value.length === 1 && keysToConvert.includes(key)) {
  //     if (this.DragData[key]) {
  //       this.DragData[key] = value[0];
  //     }
  //   }

  //   // if (value.length === 1) {
  //   //   const key = 'Active Ingredient';
  //   //   if (this.DragData[key]) {
  //   //     this.DragData[key] = value[0];
  //   //   }
  //   // }
  //   this.DragData = { ...this.DragData };
  // }

  // deleteRow(Obj, index: number) {
  //   let objdata: any = this.DragData;
  //   if (index > 1) {
  //     Obj.splice(index, 1);
  //     console.log("deleteRow", Obj, index)
  //     this.DragData = { ...objdata };
  //   }
  // }

  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj === 'Obj') {
      // if (this.tempData[keys]) {
      //   this.tempData[keys] = event;
      // }

      const val = event && event.target ? event.target.value : event;
      if (this.tempData[keys] !== undefined) {
        this.tempData[keys] = val;
      } else {
        this.tempData[keys] = val;
      }
      // NEW: keep UI model in sync so CKEditor content isn't wiped on re-render
      this.DragData[keys] = val;
    }
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              console.log("in this obj")
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                  console.log("in this lItems")
                }
              }
            });
          } else {
          }
        });
      }
    }
    // else if (Obj === undefined) {
    //   console.log("in this")
    //   this.tempData[keys] = event.target ? event.target.value : event;
    // }

    else if (Obj === undefined) {
      // CKEditor & simple text inputs land here
      const val = event && event.target ? event.target.value : event;
      this.tempData[keys] = val;
      // NEW: also update DragData so later actions don't revert the editor content
      this.DragData[keys] = val;
    }
    // console.log("this.tempData", this.tempData);
  }

  // editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
  //   if (Obj === 'Obj') {
  //     if (this.tempData[keys]) {
  //       this.tempData[keys] = event;
  //     }
  //   } else if (Obj !== undefined) {
  //     if (this.tempData[keys] && Obj.value) {
  //       this.tempData[keys].map((res, j) => {
  //         Obj.value.map((resp, j1) => {
  //           if (j === index && j === j1) {
  //             let objkey = Object.keys(Obj.value[0]);
  //             let uniquekey = objkey[n10];
  //             resp[uniquekey] = event.target ? event.target.value : event;
  //           }
  //         });
  //       });
  //     }
  //   } else if (Obj === 'lItems') {
  //     if (Array.isArray(this.tempData[keys])) {
  //       this.tempData[keys].map((respp, k) => {
  //         if (arr) {
  //           arr.map((resps, p) => {
  //             if (p === rd) {
  //               if (resps === trows) {
  //                 arr[rd] = event.target ? event.target.value : event;
  //               }
  //             }
  //           });
  //         }
  //       });
  //     }
  //   } else if (Obj === undefined) {
  //     this.tempData[keys] = event.target ? event.target.value : event;
  //   }
  //   console.log('this.tempData', this.tempData);
  // }


  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData //JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    editedData["email"] = this.email;
    // Ensure FDA label dates are strings before sending to API
    if (this.tempData['FDA label']) {
      const rows = Array.isArray(this.tempData['FDA label'])
        ? this.tempData['FDA label']
        : [this.tempData['FDA label']];
      rows.forEach(row => {
        if (row['action date'] && row['action date'] instanceof Date) {
          row['action date'] = this.formatDate(row['action date']);
        }
      });
    }

    console.log(editedData["email"]);
    this.homeservice
      .sendSectionOneEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData["email"],
        editedData
      )
      .subscribe(
        (res: any) => {
          if (res && res.error && res.error === "Pending in LMS. Please take actions first; then editing will be allowed.") {
            this.toastr.error(res.error, "Error", {
              timeOut: 10000,   // Toast duration in milliseconds
              positionClass: 'toast-top-right',  // Position the toast in the top-right corner
              closeButton: true
            });
          }
        },
      );
  }

  // Section One UPDATE OR REJECT
  handelAction(key, flag, i) {
    if (flag === 'accept') {
      this.acceptLoader = true;
    } else {
      this.rejectLoader = true;
    }
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
      userip: localStorage.getItem("ipaddress"),
      uniqnumber: this.uniqNumber,
      email: localStorage.getItem("email"),
    };
    this.homeservice
      .updateSectionOneMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.acceptLoader = false;
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.rejectLoader = false;
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  openPdf(value) {
    // let url: any = window.open(`http://3.111.95.5/pm_backend/${value}`);
    let url: any = window.open(`${environment.ip}pm_backend/${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }

  getTooltipContent(key: string): string {
    if (this.fieldInformation && this.fieldInformation[key]) {
      return this.fieldInformation[key]
        .map(
          (item: any) =>
            `Source: ${item.source} <br> 
             LMS No: ${item.lms_unique_no} <br> 
             Approved By: ${item.field_approved_by} <br> 
             Last Update: ${item.last_update_date} <br> 
             Last Verified By: ${item.last_verified_by || "N/A"} <br> 
             Last Reviewed By: ${item.Last_reviewed_by || "N/A"} <br> 
             Last Verified Date: ${item.last_verified_date || "N/A"} <br> 
             Last Reviewed Date: ${item.last_reviewed_date || "N/A"}`
        )
        .join("<br><br>"); // Double <br> for spacing between items
    }
    return "No information available";
  }

  openReviewDialog(key: string) {
    this.selectedKey = key;
    this.displayReviewDialog = true;
  }

  fetchEmails() {
    this.homeservice.getUserMailId(this.email).subscribe(
      (response: any) => {
        console.log("API Response:", response);

        if (response && response.data) {
          this.emailList = response.data.map(item => ({ label: item.email, value: item.email })); // Correct format for p-dropdown
        } else {
          this.emailList = [];
        }

        console.log("Formatted Emails for Dropdown:", this.emailList);
      },
      error => {
        console.error("Error fetching emails:", error);
      }
    );
  }



  isCommentValid(): boolean {
    return this.selectedEmail && this.reviewComment.length >= 15;
  }

  submitReview() {
    this.submitted = true;
    if (!this.selectedEmail || !this.reviewComment || this.reviewComment.length < 15) {
      this.toastr.error("Please enter at least 15 characters in the comment.", "Error");
      return;
    }

    let selectedMoleculeData = this.selectedSubMolecule["code"];
    const reviewData = {
      user_mail: this.email,
      reviewer_email: this.selectedEmail,       // Email of the reviewer
      comment: this.reviewComment,     // Review comment (at least 15 chars)
      field: this.selectedKey,         // Field that is being reviewed
      section: "INNOVATOR/BRAND PRODUCT DETAILS",   // Hardcoded section name
      drugBrandName: selectedMoleculeData["brand_name"],         // Brand Name from API response
      drugNdaNumber: selectedMoleculeData["nda_number"],   // NDA Number from API response
      // drugDosageForm: this.drugDosageForm  // Dosage Form from API response
    };

    console.log('Submitting:', reviewData);

    this.homeservice.submitFieldReview(reviewData).subscribe(
      (response) => {
        console.log("Review submitted successfully:", response);
        this.toastr.success("Reviewed field successfully", "Success");
        this.reviewComment = '';
        this.selectedEmail = '';
        this.displayReviewDialog = false;
        this.fieldInformation[this.selectedKey][0].field_reviewed = true; // Disable Review button
        this.fieldInformation[this.selectedKey][0].field_verified = false;
      },
      (error) => {
        console.error("Error submitting review:", error);
        this.toastr.error("Failed to submit review. Try again.", "Error");
      }
    );
  }

  verifyField(fieldKey: string) {
    const fieldInfo = this.fieldInformation[fieldKey];

    if (!fieldInfo) {
      this.toastr.error('Field information not found!', 'Error');
      return;
    }

    if (fieldInfo.field_verified) {
      this.toastr.info('Already Verified!', 'Info');
      return;
    }

    let selectedMoleculeData = this.selectedSubMolecule["code"];

    const payload = {
      user_mail: this.email,
      field_key: fieldKey,
      nda_number: selectedMoleculeData["nda_number"],             // NDA Number from API response
      brand_name: selectedMoleculeData["brand_name"],             // Brand Name from API response
    };

    console.log("Payload for verification:", payload);

    this.homeservice.verifyFieldData(payload).subscribe(
      (response) => {
        this.toastr.success("Field verified successfully", "Success");
        this.fieldInformation[fieldKey][0].field_verified = true;
        this.fieldInformation[fieldKey][0].field_reviewed = false;

        // this.getpatentInfo();
      },
      (error) => {
        console.error("Error in Field verified", error);
        this.toastr.error("Failed to verify field. Try again.", "Error");
      }
    );
  }
}